import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 * Search for deviceStatusChangeCodes.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.DEVICE_STATUS_CHANGE_CODES,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const DeviceStatusChangeCodeService = {
  FindMany
}

export default DeviceStatusChangeCodeService
